// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as ZonesAndClustersEntityMapper from "../entity-mapper/ZonesAndClustersEntityMapper.bs.js";

function execute(data) {
  return ZonesAndClustersEntityMapper.Zones.execute(data);
}

var ZoneListResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var ZoneListResponseConverter = partial_arg(ZoneListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return ZonesAndClustersEntityMapper.Clusters.execute(data);
}

var ClusterListResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var ClusterListResponseConverter = partial_arg$1(ClusterListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  ZoneListResponseConverterConfig ,
  ZoneListResponseConverter ,
  ClusterListResponseConverterConfig ,
  ClusterListResponseConverter ,
  
}
/* ZoneListResponseConverter Not a pure module */
